'use strict';
var React = require('react');
var Moment = require('moment-timezone');
var Ladda = require('ladda');
//extend jquery with floating scroll methods
require('./lib/floatingScroll');
import Slider from 'react-slick';
import Datetime from 'react-datetime';
import PropTypes from 'prop-types';

module.exports = (function() {
    /* private properties and methods */
    let me = {};

    /* public properties and methods */

    /* packages */
    me.React = React;
    me.ReactDOM = require('react-dom');
    me.ReactAddons = {
        PropTypes: require('prop-types'),
        createReactClass: require('create-react-class')
    };
    me.ReactBeautifulDnD = require('react-beautiful-dnd');
    me.Router = require('react-router-dom');
    me.PropTypes = PropTypes;
    me.Store = require('./store.js');
    me.Moment = Moment;
    me.Formsy = require('formsy-react');
    me.Formsy.Form = require('formsy-react').default;
    me.FormsyFields = require('formsy-react-components');
    me.FormsyFields.FormsyReactComponent = require('formsy-react-components/release/hoc/component').default;
    me.FormsyFields.Help = require('formsy-react-components/release/components/help').default;
    me.FormsyFields.ErrorMessages = require('formsy-react-components/release/components/error-messages').default;
    me.FormsyFields.Info = require('formsy-react-components/release/components/info').default;
    me.FormsyFields.Footer = require('formsy-react-components/release/components/footer').default;
    me.Ladda = require('ladda');
    me.Numeral = require('numeral');
    me.Datetime = Datetime;
    me.Bootstrap = require('react-bootstrap');
    me.ImageGallery = require('./lib/image-gallery.js').default;
    window.odometerOptions = { auto: false };
    me.odometer = require('./lib/odometer.min.js');
    me.PanZoom = require('./lib/jquery.panzoom.js');
    me.ATDSuperTable = require('./lib/atd-super-table.js').default;
    me.ReactBootstrapTable = require('./lib/react-bootstrap-table.js');
    me.JSONFormatter = require('json-formatter-js');
    me.ReactOverlays = require('react-overlays');
    me.ToggleButton = require('react-toggle-button');
    me.Slider = Slider;
    me.ReactSelect = require('react-select').default;
    me.IframeResize = require('iframe-resizer');
    me.QRCode = require('qrcode.react');
    me.ReactLadda = require('react-ladda');
    me.LaddaButton = me.ReactLadda.default;
    me.ReactDeviceDetect = require('react-device-detect');
    me.GoogleMapReact = require('google-map-react').default;
    me.GoogleMapReactUtils = require('google-map-react/utils');
    me.PointsCluster = require('points-cluster').default;
    me.LzString = require("lz-string");
    me.QueryString = require("query-string");
    return me;
})();

// Extensions
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position) {
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
    };
}
if (!String.prototype.asMoment) {
    String.prototype.asMoment = function() {
        if (!this || this.startsWith('0001')) return false;
        return moment(new Date(this));
    };
}
